import { all, fork } from 'redux-saga/effects';

import applicationMapServerToUi from './applicationMapServerToUi';
import applicationRejectSaga from './applicationReject';
import applicationSubmitSaga from './applicationSubmit';
import applicationUpdateSaga from './applicationUpdate';
import campusesSaga from './campuses';
import capOnLoanSaga from './capOnLoan';
import countriesSaga from './countries';
import coursesSaga from './courses';
import eligibilitySaga from './eligibility';
import employersSaga from './employers';
import minLoanAmountSaga from './minLoanAmount';
import navigationSaga from './navigation';
import periodsSaga from './periods';
import persistAll from './persistAll';
import progressContinue from './progressContinue';
import progressFetch from './progressFetch';
import progressSend from './progressSend';
import provisionalOfferFetchSaga from './provisionalOfferFetch';
import provisionalOfferUpdateSaga from './provisionalOfferUpdate';
import schoolsSaga from './schools';
import seasonClassUpdateSaga from './seasonClassUpdate';
import statesSaga from './states';
import tokenRenewFailedSaga from './tokenRenewFailed';
import trackInHeapSaga from './trackInHeap';
import universitiesSaga from './universities';
import unpaidTuitionCostLoanCurrencyAmountSaga from './unpaidTuitionCostInLoanCurrency';
import unsupportedSchoolsInterestUpdateSaga from './unsupportedSchoolsInterestUpdate';
import unvalidatedPeriodsSaga from './unvalidatedPeriods';
import userDoSignInSaga from './userDoSignIn';
import userSignInSaga from './userSignIn';
import wizardNavigationSaga from './wizardNavigation';
import zendeskSaga from './zendesk';

export default function* rootSaga() {
  yield all([
    fork(wizardNavigationSaga),
    fork(navigationSaga),
    fork(applicationUpdateSaga),
    fork(unsupportedSchoolsInterestUpdateSaga),
    fork(seasonClassUpdateSaga),
    fork(countriesSaga),
    fork(statesSaga),
    fork(coursesSaga),
    fork(periodsSaga),
    fork(unvalidatedPeriodsSaga),
    fork(schoolsSaga),
    fork(universitiesSaga),
    fork(eligibilitySaga),
    fork(unpaidTuitionCostLoanCurrencyAmountSaga),
    fork(campusesSaga),
    fork(minLoanAmountSaga),
    fork(userSignInSaga),
    fork(userDoSignInSaga),
    fork(applicationSubmitSaga),
    fork(capOnLoanSaga),
    fork(progressSend),
    fork(progressFetch),
    fork(progressContinue),
    fork(persistAll),
    fork(applicationMapServerToUi),
    fork(employersSaga),
    fork(applicationRejectSaga),
    fork(tokenRenewFailedSaga),
    fork(trackInHeapSaga),
    fork(provisionalOfferFetchSaga),
    fork(provisionalOfferUpdateSaga),
    fork(zendeskSaga),
  ]);
}
